import { Link } from '@backstage/core-components';
import { useLinkButtonStyles } from './link-button.styles';

interface LinkButtonProps {
  to: string;
  label: string;
  solid?: boolean;
  className?: string;
  [x: string]: any;
}

export const LinkButton = (props: LinkButtonProps) => {
  const { to, label, solid, className = '', ...restProps } = props;
  const classes = useLinkButtonStyles();
  return (
    <Link
      to={to}
      className={`${classes.ctaLink} ${solid ? classes.solid : ''} ${className}`}
      {...restProps}
    >
      {label}
    </Link>
  );
};
